import React from 'react';
import PropTypes from 'prop-types';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Typography from '@mui/material/Typography';

import HoursOfOperation from './HoursOfOperation';

const detailsContainer = {
  display: 'grid',
  gridTemplate: 'auto auto auto/1fr',
  px: 0,
  py: 2,
  rowGap: 2.5,
};

const SpecialHoursAccordion = ({
  driverSatHours,
  driverSunHours,
  driverWeekdayHours,
  ethanolSatHours,
  ethanolSunHours,
  ethanolWeekdayHours,
  tranmxSatHours,
  tranmxSunHours,
  tranmxWeekdayHours,
}) => {
  return (
    <Accordion defaultExpanded sx={{ '&.Mui-expanded': { marginTop: 2 }, boxShadow: 'none' }}>
      <AccordionSummary
        aria-controls="special-hours-content"
        expandIcon={<ExpandMoreIcon sx={{ color: 'primary.main' }} />}
        id="special-hours-header"
        sx={{ '&.Mui-expanded': { backgroundColor: 'surface.light' }, px: 2 }}
      >
        <Typography variant="body1">Services with Special Hours</Typography>
      </AccordionSummary>
      <AccordionDetails sx={detailsContainer}>
        <HoursOfOperation
          saturdayHours={driverSatHours}
          sectionTitle="Driver Training"
          sundayHours={driverSunHours}
          weekdayHours={driverWeekdayHours}
        />
        <HoursOfOperation
          saturdayHours={ethanolSatHours}
          sectionTitle="Ethanol Loading"
          sundayHours={ethanolSunHours}
          weekdayHours={ethanolWeekdayHours}
        />
        <HoursOfOperation
          saturdayHours={tranmxSatHours}
          sectionTitle="Tranmx Unl Loading"
          sundayHours={tranmxSunHours}
          weekdayHours={tranmxWeekdayHours}
        />
      </AccordionDetails>
    </Accordion>
  );
};

SpecialHoursAccordion.propTypes = {
  driverSatHours: PropTypes.string.isRequired,
  driverSunHours: PropTypes.string.isRequired,
  driverWeekdayHours: PropTypes.string.isRequired,
  ethanolSatHours: PropTypes.string.isRequired,
  ethanolSunHours: PropTypes.string.isRequired,
  ethanolWeekdayHours: PropTypes.string.isRequired,
  tranmxSatHours: PropTypes.string.isRequired,
  tranmxSunHours: PropTypes.string.isRequired,
  tranmxWeekdayHours: PropTypes.string.isRequired,
};

export default SpecialHoursAccordion;
